import { Link } from 'react-router-dom';
import { homepageSeoContent } from '@/mocks/seoContent';

export default function ArticleSection() {
  const { articlesSectionTitle, articlesSectionSubtitle, articles } = homepageSeoContent;

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="text-xs font-medium text-primary-500 uppercase tracking-wider whitespace-nowrap">
              Expert Resources
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mt-3">
              {articlesSectionTitle}
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            {articlesSectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20modern%20workspace%20with%20a%20sleek%20silver%20laptop%20showing%20colorful%20spreadsheet%20charts%2C%20a%20ceramic%20mint%20green%20coffee%20cup%2C%20reading%20glasses%2C%20and%20a%20small%20potted%20monstera%20plant%20on%20a%20light%20beech%20wood%20desk%2C%20bright%20natural%20daylight%20from%20above%2C%20organized%20productive%20aesthetic%2C%20no%20text%2C%20warm%20inviting%20creative%20studio%20atmosphere&width=1200&height=750&seq=article-preview-v2-01&orientation=landscape"
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-lg font-heading text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col items-center justify-center text-center border-2 border-dashed border-background-200">
            <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mb-4">
              <i className="ri-add-line text-2xl text-primary-500"></i>
            </div>
            <h4 className="text-base font-heading text-foreground-800 mb-2">
              More Guides Coming Soon
            </h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              We are continuously adding in-depth guides, comparison articles, and shopping strategies. Stay tuned for fresh content every week.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}